import { render, staticRenderFns } from "./Attribution.vue?vue&type=template&id=006b484a"
import script from "./Attribution.vue?vue&type=script&lang=js"
export * from "./Attribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('006b484a')) {
      api.createRecord('006b484a', component.options)
    } else {
      api.reload('006b484a', component.options)
    }
    module.hot.accept("./Attribution.vue?vue&type=template&id=006b484a", function () {
      api.rerender('006b484a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/print/Attribution.vue"
export default component.exports